import {
  type ComponentPropsWithoutRef,
  type ComponentPropsWithRef,
  type CSSProperties,
  type FC,
} from 'react';
import logoSrc from 'src/assets/prisma-logo-short-colored.svg';
import { cn } from 'src/utils/cn';

export const layoutMainPaddingTop = '1rem';
export const layoutMainPaddingBottom = '10.5rem';

export const Layout = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn(
        `
          grid min-h-screen grid-rows-[auto_1fr_auto]
          [grid-template-areas:'header'_'main'_'footer']
        `,
        className
      )}
      {...props}
    />
  );
};

export const LayoutHeader: FC<
  ComponentPropsWithRef<'div'> & { fullscreen?: boolean }
> = ({ className, fullscreen, ...props }) => (
  <div
    className={cn(
      `
        sticky top-0 z-3 [grid-area:header]
        print:hidden
      `,
      fullscreen && `fixed inset-0 overflow-auto`,
      className
    )}
    {...props}
  />
);

export const LayoutMain = ({
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      style={{
        ...style,
        ...({
          '--layout-main-padding-top': layoutMainPaddingTop,
          '--layout-main-padding-bottom': layoutMainPaddingBottom,
        } as CSSProperties),
      }}
      className={cn(
        `
          h-full pt-(--layout-main-padding-top)
          pb-(--layout-main-padding-bottom) [grid-area:main]
          legacy:bg-[linear-gradient(100.87deg,rgba(86,167,216,0.15)0%,rgba(86,167,216,0.08)100%)]
        `,
        `
          print:box-border print:w-full print:[page-break-inside:avoid]
          legacy:print:mt-[10px]
        `,
        className
      )}
      {...props}
    >
      {props.children}

      <img
        src={logoSrc}
        alt="PRISMA Logo"
        aria-hidden={true}
        className={`
          absolute top-[5px] right-[5px] z-10 hidden h-2xl w-[80px]
          print:block
        `}
      />
    </div>
  );
};

export const LayoutFooter = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn(
        `
          [grid-area:footer]
          print:hidden
        `,
        className
      )}
      {...props}
    />
  );
};
